import { createIcon } from "@chakra-ui/icons";

// Created from minus.svg

export const MinusIcon = createIcon({
  displayName: "Minus",
  viewBox: "0 0 17 15",
  path: (
    <g>
      <path
        d="M1 7.36426H15.7283"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});
